import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { SharedHero } from '@hover/shared-components';
import {
  Layout,
  NewsLetterBar,
  UtilityMenuBanner,
} from '../../v2/components/common';

import {
  HowHoverWorks,
  BringYourHome,
  ReadyToSee,
  HeroButton,
} from '../../v2/components/how-does-it-work';

const HowDoesItWork: React.FC = () => (
  <Layout
    title="Measure, Design, & Estimate Home Improvement Jobs"
    description="Improving home improvement. Home improvement shouldn’t be a mystery. Know what it will look like and what it will cost before the work even begins."
    bannerElement={<UtilityMenuBanner />}
  >
    <SharedHero
      heading="Improving home improvement."
      body="Home improvement shouldn’t be a mystery. Know what it will look
      like and what it will cost before the work even begins."
      bg="red.500"
      haveContentChildren
      haveBackground
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          alt="how does it work hero"
          src="../../v2/assets/images/how_does_it_works_hero_desktop.png"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          alt="how does it work hero"
          src="../../v2/assets/images/how_does_it_works_hero_tablet.png"
        />
      }
      contentChildren={<HeroButton />}
      page="how-it-works"
    />
    <HowHoverWorks />
    <BringYourHome />
    <ReadyToSee />
    <NewsLetterBar bg="red.500" iconColor="yellow.500" />
  </Layout>
);

export default HowDoesItWork;
